import React, { useCallback, useState } from 'react';
import YesOrNoFormField from '@rd-web-markets/shared/dist/util/form_fields/YesOrNoFormField';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import useUpdateState from '../hooks/useUpdateState';
import claimGroupSubRouteService from '@rd-web-markets/shared/dist/services/claim_groups/claim_group_sub_route.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const GeneralQuestions = _ref => {
  let {
    generalQuestions,
    setGeneralQuestions
  } = _ref;
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [updateState] = useUpdateState(setGeneralQuestions, setIsNotSaved);
  const {
    t
  } = useTranslation();
  const saveData = useErrorHandling(useCallback(async body => {
    const response = await generalRouteSubRouteService.update(body.elster_id, 'elsters', 'general_question', '', body);
    setGeneralQuestions({
      ...response
    });
    setIsNotSaved(false);
  }, [setGeneralQuestions]));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, t(makeKey('Overview of the required information for the application to the tax office'))), /*#__PURE__*/React.createElement("p", {
    className: "mb-3"
  }, t(makeKey('The following information is required for the application. This includes information per financial year on wage costs throughout the enterprise and other information on the R & D project. Please complete the following tables.'))), /*#__PURE__*/React.createElement("br", null), Object.entries(generalQuestions).map((gQ, i) => {
    if (!['id', 'elster_id', 'created_at', 'updated_at'].includes(gQ[0])) {
      return /*#__PURE__*/React.createElement("div", {
        key: gQ[0]
      }, /*#__PURE__*/React.createElement(YesOrNoFormField, {
        labelText: t(makeKey(gQ[0])),
        formName: 'general_question' + i,
        checkedField: gQ[1],
        onChange: updateState,
        onChangeParams: [generalQuestions, gQ[0]]
      }));
    }
    return null;
  }), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [generalQuestions]
  }));
};
export default GeneralQuestions;